import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { getToken } from '@/lib/auth'

export default function Settings() {
  const { viewer } = useAuth()
  const [params] = useSearchParams()
  const githubStatus = params.get('github')
  const error = params.get('error')

  const connectGithub = () => {
    const token = getToken()
    window.location.href = `/auth/github/authorize?token=${encodeURIComponent(token ?? '')}`
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="flex items-center gap-3 px-4 py-3 border-b border-slate-200 bg-white">
        <Link to="/library" className="text-slate-500 hover:text-slate-800">
          ←
        </Link>
        <h1 className="text-lg font-semibold text-slate-900">Settings</h1>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8 space-y-6">
        <section className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="font-medium text-slate-900">Account</h2>
          <p className="mt-1 text-sm text-slate-500">{viewer?.email}</p>
        </section>

        <section className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="font-medium text-slate-900">GitHub</h2>
          {githubStatus === 'connected' && (
            <p className="mt-1 text-sm text-emerald-600">GitHub connected.</p>
          )}
          {error && <p className="mt-1 text-sm text-red-600">Connection failed: {error}</p>}

          {viewer?.githubConnected ? (
            <p className="mt-1 text-sm text-slate-600">
              Connected as <span className="font-medium">@{viewer.githubLogin}</span>. Book repos
              will be created under your account.
            </p>
          ) : (
            <>
              <p className="mt-1 text-sm text-slate-500">
                Connect GitHub so the app can create a private repo per book and sync translations.
              </p>
              <button
                onClick={connectGithub}
                className="mt-3 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
              >
                Connect GitHub
              </button>
            </>
          )}
        </section>
      </main>
    </div>
  )
}
